"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FitnessTrends = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FitnessTrends = exports.FitnessTrends = function () {
  function FitnessTrends() {
    (0, _classCallCheck3.default)(this, FitnessTrends);
  }

  (0, _createClass3.default)(FitnessTrends, null, [{
    key: "member",
    value: function member(_ref) {
      var meta = _ref.meta,
          summary = _ref.summary,
          modules = _ref.modules;

      return {
        year: meta.year,
        firstName: meta.first_name,
        userId: meta.user_id,
        summary: {
          minutes: summary.minutes,
          activities: summary.activities || summary.activites, // temporarily accommodates a typo in the service
          friendCount: summary.friend_count,
          studioCount: summary.studio_count,
          cityCount: summary.city_count
        },
        tiles: modules.map(function (data, index) {
          return {
            description: data.description,
            id: index,
            header: data.header,
            number: data.number,
            subheader: data.subheader,
            type: data.type
          };
        })
      };
    }
  }]);
  return FitnessTrends;
}();